import styled from 'styled-components';

export const StronInfoWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.small.s5};
  `
);

export const StrongHeadText = styled.p(
  props => `
    width:100%;
    display: flex;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const StrongSubText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.light9b};
    line-height: ${props.theme.font.lineHeight.base};
  `
);

export const TickIconWrapper = styled.div(
  props => `
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props.theme.colors.green.dark};
    border-radius: ${props.theme.misc.borderRadius.round};
    position: absolute;
    top: 2.1rem;
    right: 1rem;
    transform: translateY(-50%);
  `
);

export const TickErrorIconWrapper = styled.div(
  props => `
    width: 1.3rem;
    height: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props.theme.colors.red.base};
    border-radius: ${props.theme.misc.borderRadius.round};
    position: absolute;
    top: 2.1rem;
    right: 1rem;
    transform: translateY(-50%);
  `
);

export const CloseIco = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font8};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const EyeWrapper = styled.div(
  props => `
    position: absolute;
    height: 42px;
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const StrongPassInfo = styled.div(
  props => `
    position: absolute;
    height: 42px;
    border-right: 4px solid ${props.theme.colors.green.dark};
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const StongText = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.green.dark};
    font-weight: ${props.theme.font.fontWeight.bold};
    display: flex;
    padding-top: ${props.theme.spacing.large.l13};
    padding-right: ${props.theme.spacing.large.l45};
  `
);

export const StrongFailInfo = styled.div(
  props =>`
    position: absolute;
    height: 42px;
    border-right: 4px solid ${props.theme.colors.red.base};
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const WeakText = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.red.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    display: flex;
    padding-top: ${props.theme.spacing.large.l13};
    padding-right: ${props.theme.spacing.large.l45};
  `
);

export const UserImportantInfoWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    margin-top: ${props.theme.spacing.large.l20};
    flex-direction: column;
  `,
);

export const UserConsentText = styled.label(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    cursor: pointer;
  `,
);

export const UserTermsText = styled.span(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.base};
  `
);

export const UserTermsCheck = styled.input.attrs({type: 'checkbox'})(
  props =>`
    display: inline-flex;
    margin-right: 0.5rem;
    cursor: pointer;
    vertical-align: middle;
    position: relative;
    top: -1.5px;
  `
);
export const ForgotPasswordBlock = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: ${props.theme.spacing.large.l11};
      padding-right: ${props.theme.spacing.small.s4};

      @media only screen and (min-width:320px) and (max-width: 768px){
          padding-top: 0rem;
          justify-content: flex-end;
      }

      @media only screen and (min-width:1025px) and (max-width: 1300px){
          justify-content: flex-end;
      }
  `,
);

export const ForgotPasswordLoaderContainer = styled.div(
  props => `
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      width: 86%;
      margin-top: 5px;
  `
)
export const ForgotPasswordBlockText = styled.a(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      cursor: pointer;
  `,
)
